import { render } from "./NewReleases.vue?vue&type=template&id=2ee33dfd&scoped=true"
import script from "./NewReleases.vue?vue&type=script&lang=js"
export * from "./NewReleases.vue?vue&type=script&lang=js"

import "./NewReleases.vue?vue&type=style&index=0&id=2ee33dfd&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee33dfd"]])

export default __exports__